// This module defines interfaces representing interactions with an API data source
// and also a match function for pattern matching on the lifecycle of an API stream.

// id: unique name of the API resource e.g. "folder" or "property", for identifying merged API streams
// state: current state of the service stream, used for pattern matching
// value: for each state in an API stream lifecycle, value holds the last known good value returned from the API
// reason: unique to an error state, reason is the error message string

interface Initial<T> {
  id: string,
  state: "init",
  value: T
}

interface Ok<T> {
  id: string,
  state: "ok",
  value: T
}

interface Error<T> {
  id: string,
  state: "error",
  value: T,
  error: object
}

interface Busy<T> {
  id: string,
  state: "busy",
  value: T
}

export type ApiResult<T> = Initial<T> | Busy<T> | Ok<T> | Error<T>

export default function api_match<T>(
  r: ApiResult<T>,
  i: (_: Initial<T>) => void,
  o: (_: Ok<T>) => void,
  e: (_: Error<T>) => void,
  f: (_: Busy<T>) => void
): void {
  switch(r.state) {
    case "init": return i(r)
    case "ok": return o(r)
    case "error": return e(r)
    case "busy": return f(r)
  }
}
